module.exports = __webpack_public_path__ + "static/media/logo-terra.984a6905.png";